import React, { useRef, useContext } from 'react'
import axios from '../shared/axios'
import { store, actions } from '../../stores/multipost'

export default function MultipostForm({children, action, method}) {
  const formRef = useRef(null)
  const { dispatch, returnUrl } = useContext(store)

  const handleSubmit = (e) => {
    e.preventDefault()
    e.stopPropagation()
    dispatch({ type: actions.SET_SUBMITTING, submitting: true })
    const formData = new FormData(formRef.current)
    axios[method](action, formData)
      .then(response => {
        if (response.data.redirect_to) {
          window.location.href = response.data.redirect_to;
        }
      })
      .catch(error => {
        console.error(error)
        dispatch({ type: actions.SET_SUBMITTING, submitting: false })
      })
  }

  return (
    <form ref={formRef} onSubmit={handleSubmit}>
      {returnUrl && <input type="hidden" name="return_url" value={returnUrl} />}
      {children}
    </form>
  )
}
